import {Roles} from "../../Enums"
import { PolicyConstants } from "../constants/PolicyConstants";
import { PermissionConstants } from "../constants/PermissionConstants";

export class SepaPolicies{

    public static Name = PolicyConstants.SEPA_POLICIES;
    public static PermissionSets = [PermissionConstants.READ, PermissionConstants.EDIT, PermissionConstants.DOWNLOAD];

    private static _readRestrictions : Roles[] =
    [
        Roles.Hauptbenutzer,
        Roles.BenutzerFinanz
    ];

    private static _editRestrictions =
    [
        Roles.Hauptbenutzer,
        Roles.BenutzerFinanz
    ];

    private static _downloadRestrictions =
    [
        Roles.Hauptbenutzer,
        Roles.BenutzerFinanz
    ];

    public static GetPermissions(){
        return new Map([
            [PermissionConstants.READ, this._readRestrictions],
            [PermissionConstants.EDIT, this._editRestrictions],
            [PermissionConstants.DOWNLOAD, this._downloadRestrictions]
        ])
    }

}